import { render, staticRenderFns } from "./PanelCompetitionRegisterForm.vue?vue&type=template&id=37136ac9&scoped=true&"
import script from "./PanelCompetitionRegisterForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionRegisterForm.vue?vue&type=style&index=0&id=37136ac9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37136ac9",
  null
  
)

export default component.exports